"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcModal_1 = require("./AcModal");
var AcButton_1 = __importDefault(require("../button/AcButton"));
exports.AcInfoModal = function (props) {
    var onHide = props.onHide, title = props.title, content = props.content;
    return (react_1.default.createElement(AcModal_1.AcModal, __assign({}, props),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, { className: "p-4" },
            react_1.default.createElement("h4", { className: "h4 text-center mb-6", dangerouslySetInnerHTML: { __html: title } }),
            react_1.default.createElement("p", { className: "text-center", dangerouslySetInnerHTML: { __html: content } })),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, { className: "d-flex justify-content-center" },
            react_1.default.createElement(AcButton_1.default, { size: "lg", onClick: onHide, variant: "outline-apzlinkblue" }, "\u9589\u3058\u308B"))));
};
exports.AcInfoModal.displayName = 'AcInfoModal';
//# sourceMappingURL=AcInfoModal.js.map